import css from './ConfirmDialog.module.css'

function ConfirmDialog ({handleYes, handleNo, content}) {

    return (
        <div className={css.overlay} onClick={handleNo}>
          <div className={css.dialog}>
            <h2>{content.title}</h2>
            <p>{content.question}</p>
            <button className={css.yesButton} onClick={handleYes}>Yes</button>
            <button className={css.noButton} onClick={handleNo} autoFocus>No</button>
          </div>
        </div>
    )
}

export default ConfirmDialog;